import React, { useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';
import Modal from '../../../components/modal';
import * as XLSX from 'xlsx';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { API_URL } from '../../../utils/constant';
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import SalesBillModelReallocate from './sales_model';
import { getModulePermissions } from '../../../utils/getPermissions';
import { useLocation } from 'react-router-dom';
import ClaimModal from './claimmodel';
import ViewClaimModal from './view_claim_model';
import { Eye } from 'lucide-react';
import OldSalesBillModelReallocate from './old_product_reallocate';
import OtherClaimModal from './other_claim';
import { customTableStyles } from '../../../utils/tableStylings';
import BillFormatA4Page from '../pos/bills_format/format_a4';

const DueSalesBillsPage = () => {

    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const bill_id = query.get("bill");
    const [bills, setBills] = useState([]);
    const [loading, setLoading] = useState(true);
    const [companyData, setCompanyData] = useState([]);
    const [search, setSearch] = useState('');
    const [showReallocateModal, setShowReallocateModal] = useState(false);
    const [reallocateBill, setReallocateBill] = useState(null);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [productType, setProductType] = useState(""); // new | old
    const [oldType, setOldType] = useState(""); // AB-OS | AB-SS

    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [selectedBill, setSelectedBill] = useState(null);
    const [updateAmount, setUpdateAmount] = useState('');

    useEffect(() => {
        if (productType !== "old") {
            setOldType("");
        }
    }, [productType]);

    const fetchCompany = async (companyId) => {
        try {
            const res = await axios.get(`${API_URL}/companies/${companyId}`);
            const data = res.data;
            setCompanyData(data);
        } catch (err) {
            console.error("Failed to fetch company:", err);
        }
    };

    const fetchBills = async () => {
        try {
            setLoading(true);
            const company = JSON.parse(localStorage.getItem('company'));
            const companyId = company?.company?.id;

            const response = await axios.get(`${API_URL}/bills/due-bills/${companyId}`);
            if (response.data.success) {
                setBills(response.data.data);
            } else {
                console.error('Failed to fetch bills');
            }
            fetchCompany(companyId);
        } catch (err) {
            console.error('Error fetching bills:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBills();
    }, []);


    const columns = [
        {
            name: '#',
            cell: (row, index) => index + 1,
            width: '50px'
        },
        {
            name: 'Bill No',
            selector: row => row.bill_no,
            sortable: true
        },
        {
            name: 'Bill For',
            selector: row => row.bill_for,
            sortable: true
        },
        {
            name: 'Customer',
            cell: row => (
                <div style={{ display: 'block' }}>
                    <div ><strong>{row.Customer?.name || 'N/A'}</strong></div>
                    <div className="text-muted">{row.Customer?.phone || '-'}</div>
                </div>
            )
        },
        {
            name: "Products",
            grow: 2,
            width: "280px",
            cell: row => (
                <div
                    style={{
                        // maxHeight: "140px",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                        paddingRight: "4px",
                        paddingTop: "4px",
                        paddingBottom: "4px"
                    }}
                >
                    {row.product_data.map((p, i) => (
                        <div
                            key={i}
                            className="border rounded p-1 bg-primary"
                            style={{ fontSize: "12px" }}
                        >
                            {/* Product name */}
                            <div
                                className="fw-semibold text-white"
                                title={p.product_name}
                                style={{
                                    maxWidth: "100%",
                                    marginBottom: "2px",
                                    whiteSpace: "wrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}
                            >
                                {p.product_name} - {(p.product_type === "AB-OS" || p.product_type === "AB-SS") && (
                                    <span className="ms-1 text-warning">
                                        ({p.product_type})
                                    </span>
                                )}
                            </div>

                            {/* Serial numbers */}
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "4px"
                                }}
                            >
                                {p.serial_nos?.map((s, j) => (
                                    <span
                                        key={j}
                                        className="badge bg-white border text-dark"
                                        style={{ fontSize: "11px" }}
                                    >
                                        {s.serial_no}
                                    </span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )
        },
        {
            name: 'Discount',
            selector: row => `₹${(row.discountAmount || 0).toFixed(2)}`,
            right: true
        },
        {
            name: 'Remaining Amount',
            cell: row => {

                return (
                    <span className={`badge badge-danger text-white fs-13`}>
                        ₹{row.remaining_amount.toFixed(2)}
                    </span>
                );
            },
            right: false
        },
        {
            name: 'Total',
            selector: row => `₹${(row.total || 0).toFixed(2)}`,
            right: true
        },
        {
            name: 'Date',
            selector: row => moment(row.createdAt).format('DD-MM-YYYY hh:mm A'),
            sortable: true
        },
        {
            name: 'Actions',
            cell: row => (
                <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => handleUpdateAmount(row)}
                >
                    Update Amount
                </button>
            ),
            width: '120px'
        }
    ];
    // Re-Allocate Modal State

    const handleUpdateAmount = (row) => {
        setSelectedBill(row);
        setUpdateAmount(row.remaining_amount); // prefill
        setShowUpdateModal(true);
    };

    const handleSubmitUpdateAmount = async () => {
        try {
            if (!updateAmount || updateAmount <= 0) {
                alert("Enter valid amount");
                return;
            }

            const company = JSON.parse(localStorage.getItem('company'));
            const companyId = company?.company?.id;

            await axios.post(`${API_URL}/bills/sales-bills/update-remaining/${companyId}`, {
                bill_id: selectedBill.id,
                paid_amount: updateAmount
            });

            Swal.fire('Success', 'Payment updated successfully', 'success');

            setShowUpdateModal(false);
            setSelectedBill(null);
            setUpdateAmount('');

            fetchBills(); // refresh list

        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Failed to update amount', 'error');
        }
    };
    // Filter bills by search (now includes customer name and phone)
    // Filter bills by search (now includes customer name and phone)
    const filteredBills = bills.filter(bill => {
        // If bill_id is provided, only return that specific bill
        if (bill_id) {
            console.log(bill.bill_no.toLowerCase(), bill_id.toLowerCase());
            return bill.bill_no.toLowerCase() == `${bill_id.toLowerCase()}`;
        }

        const searchTerm = search.toLowerCase();

        // If no search term, return all bills
        if (!searchTerm) {
            return true;
        }

        // Check bill_no, order_no
        if ((bill.bill_no && bill.bill_no.toLowerCase().includes(searchTerm)) ||
            (bill.order_no && bill.order_no.toLowerCase().includes(searchTerm))) {
            return true;
        }

        // Check customer name and phone
        if (bill.Customer && (
            (bill.Customer.name && bill.Customer.name.toLowerCase().includes(searchTerm)) ||
            (bill.Customer.phone && bill.Customer.phone.toLowerCase().includes(searchTerm))
        )) {
            return true;
        }

        // Check product_name, color, size, serial_no in product_data
        if (bill.product_data && bill.product_data.some(p =>
            (p.product_name && p.product_name.toLowerCase().includes(searchTerm)) ||
            (p.color && p.color.toLowerCase().includes(searchTerm)) ||
            (p.size && p.size.toLowerCase().includes(searchTerm)) ||
            (p.serial_nos && p.serial_nos.some(s => s.serial_no && s.serial_no.toLowerCase().includes(searchTerm)))
        )) {
            return true;
        }

        return false;
    });

    // Excel Export Handler
    const handleExportExcel = () => {
        Swal.fire({
            title: 'Export Excel',
            text: 'Do you want to export bills for a specific date range?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, select range',
            cancelButtonText: 'No, export all',
        }).then(async (result) => {
            let billsToExport = filteredBills;
            if (result.isConfirmed) {
                const { value: formValues } = await Swal.fire({
                    title: 'Select Date Range',
                    html:
                        '<div class="d-flex gap-2">' +
                        '<input id="swal-input1" type="date" class="swal2-input" placeholder="Start Date">' +
                        '<input id="swal-input2" type="date" class="swal2-input" placeholder="End Date">' +
                        '</div>',
                    focusConfirm: false,
                    preConfirm: () => {
                        return [
                            document.getElementById('swal-input1').value,
                            document.getElementById('swal-input2').value
                        ];
                    }
                });
                if (formValues && formValues[0] && formValues[1]) {
                    const startDate = moment(formValues[0], 'YYYY-MM-DD').startOf('day');
                    const endDate = moment(formValues[1], 'YYYY-MM-DD').endOf('day');
                    billsToExport = filteredBills.filter(bill => {
                        const billDate = moment(bill.createdAt);
                        return billDate.isBetween(startDate, endDate, null, '[]');
                    });
                }
            }
            // Filter out bills where any product_name contains 'demo'
            const filteredBillsToExport = billsToExport.filter(bill =>
                !bill.product_data.some(p =>
                    p.product_name && p.product_name.toLowerCase().includes('demo')
                )
            );
            // Prepare data for Excel
            const excelData = filteredBillsToExport.map(bill => ({
                'Bill No': bill.bill_no,
                'Order No': bill.order_no,
                'Customer Name': bill.Customer?.name || '',
                'Customer Phone': bill.Customer?.phone || '',
                'Products': bill.product_data.map(p => p.product_name).join(', '),
                'Total': bill.total,
                'Date': moment(bill.createdAt).format('DD-MM-YYYY'),
                'Time': moment(bill.createdAt).format('hh:mm A'),
                'Is Draft': bill.isDraft == '1' ? 'Draft' : 'Completed',
                'Mode of Payment': bill.mode_of_payment || '',
                'Cash': bill.cash || '',
                'Return': bill.returned || ''
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'SalesBills');
            XLSX.writeFile(workbook, 'SalesBills.xlsx');
        });
    };

    const filteredData = useMemo(() => {
        return filteredBills.filter(item => {
            const created = new Date(item.createdAt);

            /* DATE RANGE */
            if (fromDate && created < new Date(fromDate)) return false;

            if (toDate) {
                const end = new Date(toDate);
                end.setHours(23, 59, 59, 999);
                if (created > end) return false;
            }

            /* PRODUCT TYPE */
            if (productType) {
                if (productType === "new" && Number(item.is_other) !== 0) return false;
                if (productType === "old" && Number(item.is_other) !== 1) return false;
            }

            /* OLD TYPE */
            if (productType === "old" && oldType && item.old_type !== oldType) return false;

            return true;
        });
    }, [filteredBills, fromDate, toDate, productType, oldType]);




    return (
        <>
            <div className='card' style={{ marginTop: '60px' }}>
                <div className='card-header d-flex justify-content-between align-items-center flex-wrap gap-2'>
                    <h3 className='text-primary mb-0'>Due Sales Bills</h3>
                    <div className="d-flex align-items-end gap-2 flex-wrap">

                        {/* SEARCH */}
                        <div className='position-relative flex-grow-1' style={{ minWidth: "200px" }}>
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                Search
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Bill No, Order No, Product, Serial, Color, Size..."
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                            />
                        </div>

                        {/* FROM DATE */}
                        <div className='position-relative '>
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                From Date
                            </span>
                            <input
                                type="date"
                                className="form-control"
                                value={fromDate || ""}
                                onChange={e => setFromDate(e.target.value)}
                            />
                        </div>

                        {/* TO DATE */}
                        <div className='position-relative'>
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                To Date
                            </span>
                            <input
                                type="date"
                                className="form-control"
                                value={toDate || ""}
                                onChange={e => setToDate(e.target.value)}
                            />
                        </div>

                        {/* PRODUCT TYPE */}
                        <div className='position-relative'>
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                Product Type
                            </span>
                            <select
                                className="form-select"
                                value={productType}
                                onChange={e => setProductType(e.target.value)}
                            >
                                <option value="">All</option>
                                <option value="new">Existing Products</option>
                                <option value="old">Old Products</option>
                            </select>
                        </div>

                        {/* RESET */}
                        <div>
                            <button
                                className="btn btn-danger"
                                onClick={() => {
                                    setSearch("");
                                    setFromDate(null);
                                    setToDate(null);
                                    setProductType("");
                                    setOldType("");
                                }}
                            >
                                Reset
                            </button>
                        </div>

                        {/* EXPORT */}
                        {getModulePermissions({ module: 'Accounts', type: 'Sales Bill Export' }) && (
                            <div>
                                <button
                                    className="btn btn-success"
                                    type="button"
                                    onClick={handleExportExcel}
                                >
                                    Export Excel
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <div className='card-body'>
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                        striped
                        responsive
                        customStyles={customTableStyles}
                    />
                </div>
            </div>

            <Modal
                show={showUpdateModal}
                onClose={() => setShowUpdateModal(false)}
                title="Update Payment"
            >
                <div className="p-3">
                    <div className="mb-2">
                        <strong>Bill No:</strong> {selectedBill?.bill_no}
                    </div>

                    <div className="mb-2">
                        <strong>Last Payment Mode:</strong> {selectedBill?.mode_of_payment}
                    </div>

                    <div className="mb-2">
                        <strong>Remaining:</strong> ₹{selectedBill?.remaining_amount}
                    </div>

                    <div className="position-relative mt-3">
                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                            Enter Amount
                        </span>

                        <input
                            type="number"
                            className="form-control"
                            value={updateAmount}
                            onChange={(e) => setUpdateAmount(e.target.value)}
                            placeholder="Enter received amount"
                        />
                    </div>

                    {/* Calculation */}
                    {(() => {
                        const received = parseFloat(updateAmount || 0);
                        const remaining = parseFloat(selectedBill?.remaining_amount || 0);

                        if (!received) return null;

                        if (received > remaining) {
                            return (
                                <div className="mt-2 text-success">
                                    Return: ₹{Math.ceil(received - remaining)}
                                </div>
                            );
                        }

                        if (received < remaining) {
                            return (
                                <div className="mt-2 text-danger">
                                    Still Remaining: ₹{Math.ceil(remaining - received)}
                                </div>
                            );
                        }

                        return (
                            <div className="mt-2 text-success">
                                Full Payment Done
                            </div>
                        );
                    })()}

                    <div className="d-flex justify-content-end mt-3">
                        <button
                            className="btn btn-secondary me-2"
                            onClick={() => setShowUpdateModal(false)}
                        >
                            Cancel
                        </button>

                        <button
                            className="btn btn-primary"
                            onClick={handleSubmitUpdateAmount}
                        >
                            Update Payment
                        </button>
                    </div>
                </div>
            </Modal>


        </>
    );
};

export default DueSalesBillsPage;
